export * from './src/ricos-v1-service-services.meta.js';
